'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/* injects from baggage-loader */

exports.default = ['#de0b73', '#ff3c3b', '#de2a0b', '#ff4a00', '#ff8000', '#de9a0b', '#ffc107', '#fbf60d', '#0dfbd4', '#baf030', '#60db13', '#0ac272', '#0d9ffb', '#0b56de', '#2d11af', '#9e41ff', '#323232', '#727272', '#a6a6a6', '#d0d0d0'];


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/ColorsSet.js
// module id = 211
// module chunks = 1